import type { Translation } from '../types.ts';
import type en from '../en/shell.ts';

export default {
    nav: {
        sections: {
            content: 'Inhoud',
            customers: 'Klanten',
            commerce: 'Verkoop',
            insights: 'Inzichten',
            system: 'Systeem',
        },
        dashboard: 'Dashboard',
        pages: "Pagina's",
        articles: 'Artikelen',
        landing: "Landingspagina's",
        media: 'Media',
        portfolio: 'Portfolio',
        faq: 'FAQ',
        menus: "Menu's",
        redirects: 'Doorverwijzingen',
        customers: 'Klanten',
        customerGroups: 'Klantgroepen',
        vehicleStock: 'Voertuigvoorraad',
        orders: 'Bestellingen',
        products: 'Producten',
        categories: 'Categorieën',
        productOptions: 'Productopties',
        catalogDiscounts: 'Cataloguskortingen',
        vouchers: 'Kortingscodes',
        giftCards: 'Cadeaubonnen',
        shipping: 'Verzending',
        holidayClosure: 'Vakantiesluiting',
        deliverySlots: 'Bezorgmomenten',
        newsletter: 'Nieuwsbrief',
        reviewRequests: 'Reviewverzoeken',
        abandonedCarts: 'Verlaten winkelwagens',
        formSubmissions: 'Formulierinzendingen',
        statistics: 'Statistieken',
        websites: 'Websites',
        users: 'Gebruikers',
        vat: 'Btw',
        taxTable: 'Btw-tarieven',
    },
    badges: {
        ordersToShip: '{n} betaalde bestelling te verzenden | {n} betaalde bestellingen te verzenden',
        unreadSubmissions: '{n} ongelezen inzending | {n} ongelezen inzendingen',
    },
    madeBy: 'Gemaakt door {gsid}',
    sidebar: {
        open: 'Zijbalk openen',
        close: 'Zijbalk sluiten',
        versionTitle: 'CMS {version}, gebouwd op {date}',
    },
    impersonation: {
        viewingAs: 'Ingelogd als {email}',
        by: '(vanuit {email})',
        exit: 'Terug naar eigen account',
        exiting: 'Terugkeren…',
    },
    websites: {
        search: 'Websites zoeken…',
        noMatch: 'Geen websites gevonden.',
        more: 'Nog {n}, verfijn je zoekopdracht.',
        settings: 'Website-instellingen',
        openLive: '{host} openen in een nieuw tabblad',
        viewLive: 'Live site bekijken',
    },
    userMenu: {
        profile: 'Profiel',
        theme: 'Thema',
        logout: 'Uitloggen',
    },
    theme: {
        system: 'Systeem',
        light: 'Licht',
        dark: 'Donker',
    },
    notFound: {
        message: 'Die pagina bestaat niet.',
        back: 'Terug naar het dashboard',
    },
} satisfies Translation<typeof en>;
